import { NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem } from "namirasoft-core";
import { AccountRow, LockInputRow, LockRow, NamirasoftERPMetaDatabase, PartyRow, PartyTypeRow } from "namirasoft-erp";
import { NSBox, NSBoxBoolean, NSBoxDateTime, NSBoxEntity, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScope, ErpScopeField, ErpScopeMode } from "../ErpScope";

interface LockEditPageProps extends NSARouterMakerResult, ErpRouterProps { isEdit: boolean; }

export default class LockEditPage extends Component<LockEditPageProps>
{
    Account = createRef<NSBoxEntity<AccountRow>>();
    PartyType = createRef<NSBoxEntity<PartyTypeRow>>();
    Party = createRef<NSBoxEntity<PartyRow>>();
    ToDateTime = createRef<NSBoxDateTime>();
    Enabled = createRef<NSBoxBoolean>();
    Description = createRef<NSBoxTextArea>();

    override render()
    {
        let db = new NamirasoftERPMetaDatabase(this.props.account.token_manager, console.error);

        return (
            <ErpLayout<LockRow, LockInputRow>
                {...this.props}
                mode={ErpScopeMode.Select}
                fields={[ErpScopeField.Company, ErpScopeField.Branch]}
                pages={{
                    entity: ErpEntities.lock(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): LockInputRow => ({
                                        company_id: ErpScope.getCompanyId() ?? "",
                                        branch_id: ErpScope.getBranchId() ?? "",
                                        account_id: this.Account.current?.getValueOne() || null,
                                        party_type_id: this.PartyType.current?.getValueOne() || null,
                                        party_id: this.Party.current?.getValueOne() || null,
                                        to_date_time: new Date(this.ToDateTime.current?.getValue() ?? new Date().toISOString()),
                                        enabled: this.Enabled.current?.getValueBool() ?? true,
                                        description: this.Description.current?.getValue() ?? null,
                                        lock_category: [],
                                        lock_tag: [],
                                        lock_field: [],
                                    }),
                                    setRow: (row: LockRow) =>
                                    {
                                        ErpScope.set({ company_id: row.company_id, branch_id: row.branch_id });
                                        this.Account.current?.setValueOne(row.account_id);
                                        this.PartyType.current?.setValueOne(row.party_type_id);
                                        this.Party.current?.setValueOne(row.party_id);
                                        this.ToDateTime.current?.setValue(new Date(row.to_date_time).toISOString());
                                        this.Enabled.current?.setValueBool(row.enabled);
                                        this.Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxEntity<AccountRow>
                        ref={this.Account} title="Account" info={{ link: "https://namirasoft.com/erp/console-guide/lock/#field-account-id" }} required={false} multiple={false}
                        table_name="account" table={db.tables.account}
                        list={(filters, page, size, sorts) =>
                        {
                            let f: FilterItem[] = filters ? [...filters] : [];
                            f = ErpScope.pushFilter(f, db.tables.account, "company_id", ErpScope.getCompanyId());
                            f = ErpScope.pushFilter(f, db.tables.account, "branch_id", ErpScope.getBranchId());
                            return this.props.servers.erp.account.List(f, page, size, sorts, null);
                        }}
                        getValue={(item) => item.id} getTitle={(item) => item.name} getSort={() => null}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxEntity<PartyTypeRow>
                        ref={this.PartyType} title="Party Type" info={{ link: "https://namirasoft.com/erp/console-guide/lock/#field-party-type-id" }} required={false} multiple={false}
                        table_name="party_type" table={db.tables.party_type}
                        list={(filters, page, size, sorts) =>
                        {
                            let f: FilterItem[] = filters ? [...filters] : [];
                            f = ErpScope.pushFilter(f, db.tables.party_type, "company_id", ErpScope.getCompanyId());
                            f = ErpScope.pushFilter(f, db.tables.party_type, "branch_id", ErpScope.getBranchId());
                            return this.props.servers.erp.party_type.List(f, page, size, sorts, null);
                        }}
                        getValue={(item) => item.id} getTitle={(item) => item.name} getSort={() => null}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxEntity<PartyRow>
                        ref={this.Party} title="Party" info={{ link: "https://namirasoft.com/erp/console-guide/lock/#field-party-id" }} required={false} multiple={false}
                        table_name="party" table={db.tables.party}
                        list={(filters, page, size, sorts) =>
                        {
                            let f: FilterItem[] = filters ? [...filters] : [];
                            f = ErpScope.pushFilter(f, db.tables.party, "company_id", ErpScope.getCompanyId());
                            f = ErpScope.pushFilter(f, db.tables.party, "branch_id", ErpScope.getBranchId());
                            return this.props.servers.erp.party.List(f, page, size, sorts, null);
                        }}
                        getValue={(item) => item.id} getTitle={(item) => item.name} getSort={() => null}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxDateTime ref={this.ToDateTime} required title="To Date Time" info={{ link: "https://namirasoft.com/erp/console-guide/lock/#field-to-date-time" }} style={{ width: NSBox.width.double }} />
                    <NSBoxBoolean ref={this.Enabled} required checked={true} title="Enabled" info={{ link: "https://namirasoft.com/erp/console-guide/lock/#field-enabled" }} style={{ width: NSBox.width.double }} />
                    <NSBoxTextArea ref={this.Description} required={false} title="Description" info={{ link: "https://namirasoft.com/erp/console-guide/lock/#field-description" }} style={{ width: NSBox.width.double }} />
                </NSColumn>
            </ErpLayout>
        );
    }
}